import { render } from "./MultiFactorSelect.vue?vue&type=template&id=535971b8&scoped=true"
import script from "./MultiFactorSelect.vue?vue&type=script&lang=js"
export * from "./MultiFactorSelect.vue?vue&type=script&lang=js"

import "./MultiFactorSelect.vue?vue&type=style&index=0&id=535971b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535971b8"]])

export default __exports__